import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ButtonAddCartComponent from './ButtonAddCartComponent';
import {
  addPhotoInCart,
  setIsPhotoCartOpen,
} from '~/containers/Layout/actions';
// import { addPhoto, toggleSlider } from './actions';
// import { openModal } from '../LoginModal/actions';

function mapStateToProps(state) {
  return {
    layout: state.layout,
    profile: state.auth.profile,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      addPhotoInCart,
      setIsPhotoCartOpen,
    },
    dispatch,
  );
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ButtonAddCartComponent);
